export default __webpack_public_path__ + "static/media/folder-star-active.5b8e5bfb.svg";